import gql from 'graphql-tag';

export const UPDATE_CREATIVE_STATE = gql`
  mutation UpdateCreativeState($creativeIds: [ID!]!, $status: CreativeStatusEnum!) {
    updateCreativeState(creativeIds: $creativeIds, status: $status) {
      facebookAds {
        facebookAdId
        facebookState
        adsManagerUrl
      }
      errors
    }
  }
`;
